module.exports = __webpack_public_path__ + "img/testimonial-3-61x61_1testimonial-3-61x61.25f12cbf.png";